<div class="flex flex-col soft-card rounded">
  <div class="soft-overline">{{'#GESAMTABFRAGE.TITLE' | translate}}</div>
</div>
